<template>
    <div class="modal fade" id="vueDeletionConfirmationModal" tabindex="-1 " role="dialog " aria-labelledby="vueDeletionConfirmationLabel">
        <div class="modal-dialog" role="document" v-cloak>
            <div class="modal-content">
                <div class="modal-header">
                    <button v-on:click="cancelAction" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"></span>
                    </button>
                    <h2 class="modal-title">Remove Item(s)</h2>
                </div>
                <div class="modal-body">
                    Are you sure you want to remove the item(s) from your shopping cart?
                    <div class="btn-wrap text-right">
                        <a class="btn btn-danger" v-on:click="submitData">Remove</a>
                        <a class="btn btn-danger" v-on:click="cancelAction">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    export default {
        props: {
            onSubmit: {
                type: String,
                required: false,
                default: function () {
                    return 'onDeletionConfirmationPopupSubmit';
                }
            }
        },
        data: function () {
            return this.getDefaultData();
        },
        created: function () {
            Event.$on('deletionConfirmationPopupInvokeModal', this.onPopupInvokeModal);
        },
        beforeDestroy: function () {
            Event.$off('deletionConfirmationPopupInvokeModal', this.onPopupInvokeModal);
        },
        methods: {
            getDefaultData: function () {
                return {
                    onSubmitEvent: this.onSubmit,
                    payload: {}
                }
            },
            onPopupInvokeModal: function (payload) {
                this.payload = payload;
                $('#vueDeletionConfirmationModal').modal('show');
            },
            submitData: function () {
                $('#vueDeletionConfirmationModal').modal('hide');
                Event.$emit(this.onSubmitEvent, this.payload);
                this.payload = {};
            },
            cancelAction: function () {
                $('#vueDeletionConfirmationModal').modal('hide');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// deletion-confirmation.vue?709037ec